import { titleFromSlug } from '@/hooks/titleFromSlug'
import { useIntegrationsModalOptional } from '@/components/IntegrationsModal/IntegrationsModalContext'
import { useConnectCard } from '@/features/chat/phase1/useConnectCard'
import ContextCard from '@/components/ContextCard/ContextCard'
import ConnectAppRow from '@/components/ContextCard/ConnectAppRow'

export default function ConnectCardBlock({ block }) {
  const { state, run } = useConnectCard(block)
  const integrationsModal = useIntegrationsModalOptional()
  const app = block.toolkit ? titleFromSlug(block.toolkit) : 'an app'
  const openPicker = integrationsModal?.openIntegrations
  const onClick = block.toolkit ? run : () => openPicker?.()
  const activity = state === 'connected' ? 'success' : 'connect'
  return (
    <ContextCard activity={activity} title="Connect apps to proceed">
      <ConnectAppRow
        app={app}
        slug={block.toolkit}
        reason={block.reason}
        state={state}
        disabled={!block.toolkit && !openPicker}
        onClick={onClick}
      />
    </ContextCard>
  )
}
